import { createSlice } from "@reduxjs/toolkit";
import { fetchAllOrders } from "../actions/orders";

const initialState = {
  orders: [],
  loading: false,
  error: null,
};

const allOrderSlice = createSlice({
  name: "allOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(fetchAllOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default allOrderSlice.reducer;
